<template lang="pug">
  .module__main
    .module-content__container(v-loading="isLoading")
      .filters__container
        .date__container
          el-date-picker(
            v-model="date"
            type="datetimerange"
            range-separator="-"
            start-placeholder="От"
            end-placeholder="До"
            :picker-options="dateOptions"
          )
        el-button(type="primary" @click="startLoadStats()" :disabled="isLoading || !dates") Запросить
      .stats__block(v-if="generalStats.requested")
        .stats__container
          .stat__container
            .stat__title Заявок запрошено:
            .stat__value {{ generalStats.requested }}
          .stat__container
            .stat__title Заявок обработано:
            .stat__value {{ `${generalStats.handled} (${generalStats.handled_percent}%)` }}
          .stat__container
            .stat__title Завершено заявок:
            .stat__value {{ `${generalStats.finished} (${generalStats.finished_percent}%)` }}
          .stat__container
            .stat__title Оборота обработанно в фиате:
            .stat__value {{ `${generalStats.turnover_handled}/${generalStats.turnover_requested} р. (${generalStats.turnover_handled_percent}%)` }}
          .stat__container
            .stat__title Оборот завершенных:
            .stat__value {{ `${generalStats.turnover_fiat_amount_finished} р. (${generalStats.turnover_btc_amount_finished} BTC)` }}
          .stat__container
            .stat__title Комиссия площадки по завершенным:
            .stat__value {{ generalStats.btc_commission }} BTC
          .stat__container
            .stat__title Общая прибыль:
            .stat__value {{ generalStats.btc_profit }} BTC
          .payment-system__container(
            v-for="(paymentSystemStats, paymentSystem) in paymentSystemsStats"
            :key="`stats-total-ps-${paymentSystem}`"
          )
            .payment-system__title {{ paymentSystems[paymentSystem] || paymentSystem }}
            .stats__container
              .stat__container
                .stat__title Заявок обработано:
                .stat__value {{ `${paymentSystemStats.handled}` }}
              .stat__container
                .stat__title Завершено заявок:
                .stat__value {{ `${paymentSystemStats.finished} (${paymentSystemStats.finished_percent}%)` }}
              .stat__container
                .stat__title Общий оборот в фиате:
                .stat__value {{ `${paymentSystemStats.turnover_handled} р.` }}
              .stat__container
                .stat__title Оборот завершенных:
                .stat__value {{ `${paymentSystemStats.turnover_fiat_amount_finished} р. (${paymentSystemStats.turnover_btc_amount_finished} BTC)` }}
              .stat__container
                .stat__title Комиссия площадки по завершенным:
                .stat__value {{ paymentSystemStats.btc_commission }} BTC
              .stat__container
                .stat__title Общая прибыль:
                .stat__value {{ paymentSystemStats.btc_profit }} BTC
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { LOAD_STATS } from '@/store/const/settings';

export default {
  name: 'Balance',
  data() {
    return {
      date: '',
      dateOptions: {
        shortcuts: [{
          text: 'Сегодня',
          onClick(picker) {
            const start = new Date();
            const end = new Date();
            start.setHours(0, 0, 0, 0);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Сутки',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', [start, end]);
          }
        },  {
          text: 'Вчера',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setDate(start.getDate() - 1);
            start.setHours(0, 0, 0, 0);
            end.setDate(end.getDate() - 1);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Неделя',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Месяц',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '3 месяца',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  computed: {
    ...mapGetters([
      'loading',
    ]),
    ...mapGetters('settings', [
      'stats',
      'paymentSystems',
    ]),
    isLoading() {
      return this.loading(LOAD_STATS) === 'loading';
    },
    dates() {
      if (Array.isArray(this.date)) {
        const from = new Date(this.date[0]);
        const to = new Date(this.date[1]);
        from.setMinutes(from.getMinutes() - from.getTimezoneOffset()); // SET TO UTC 0
        to.setMinutes(to.getMinutes() - to.getTimezoneOffset()); // SET TO UTC 0
        from.setMinutes(from.getMinutes() - 180); // SET TO UTC +3
        to.setMinutes(to.getMinutes() -180); // SET TO UTC +3
        return {
          from: from.getTime(),
          to: to.getTime(),
        }
      } else {
        return null;
      }
    },
    generalStats() {
      return this.stats.general;
    },
    paymentSystemsStats() {
      return this.stats.paymentSystems;
    }
  },
  methods: {
    ...mapActions('settings', {
      loadStats: LOAD_STATS,
    }),
    async startLoadStats() {
      await this.loadStats(this.dates);
    }
  }
};
</script>
<style scoped>
.filters__container {
  display: flex;
  padding: 5px;
  background-color: #efefef;
  align-content: center;
}

.stats__block {
    display: flex;
    flex-wrap: wrap;
    overflow-y: scroll;
}

.stats__container {
    padding: 8px;
    margin: 5px 4px;
    border-radius: 10px;
    background-color: #efefef;
    width: fit-content;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.stats__title {
    font-weight: bold;
    font-size: 12px;
    margin-bottom: 5px;
}

.stat__container {
    font-family: monospace;
}

.date__container {
    margin: 0 10px;
}

.stat__title {
    font-weight: 500;
    margin-right: 5px;
    display: inline-block;
}

.stat__value {
    display: inline-block;
}

.payment-system__container {
    padding: 10px;
    border: 1px solid #c5c1c1;
    position: relative;
    background-color: #e3e3e363;
    margin-top: 5px;
}

.payment-system__title {
    font-size: 12px;
    position: absolute;
    right: 5px;
    top: 5px;
    padding: 2px;
    border: 1px solid #5e5edb;
    background-color: #d2d2ff;
    border-radius: 2px;
}

</style>
